import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import { ButtonPresentationProps, ButtonWrapper } from "@insite/mobius/Button";
import { StyledButton } from "@insite/mobius/Clickable";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { InputStyle, TextFieldProps } from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    showPrice: boolean;
    showAddToList: boolean;
    showAvailability: boolean;
    productContext: ProductPriceDto | null | undefined;
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
    view: state.pages.productList.view,
    isAuthenticated: state.context.session!.isAuthenticated,
    settingsCollection: getSettingsCollection(state),
});

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> &
    HasProductContext &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps;

export interface ProductListActionsStyles {
    wrapper?: InjectableCss;
    wrapperGridView?: InjectableCss;
    addToCartWrapper?: InjectableCss;
    addToCartWrapperGridView?: InjectableCss;
    addToCartButton?: ButtonPresentationProps;
    quantityOrdered?: TextFieldProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    addToListLink?: ProductAddToListLinkStyles;
    addToListWrapperGridView?: InjectableCss;
    addToListWrapper?: InjectableCss;
    logincontainer?: InjectableCss;
    logincontainerGridView?: InjectableCss;
    loginToSeePriceButton?: ButtonPresentationProps;
    availabilityWrapper?: InjectableCss;
    availabilityTableWrapper?: InjectableCss;
    pricingMainWrapper?: InjectableCss;
    availabilityStyles?: ProductAvailabilityStyles;
    productActionStyles?: InjectableCss;
    productActionStylesGridView?: InjectableCss;
}

export const actionsStyles: ProductListActionsStyles = {
    productActionStyles: {
        css: css`
        padding: 15px;
        padding-top: 0px;
        white-space: pre-wrap;
        display: flex;
        flex-direction: column;
        text-align: left !important;
        >${TypographyStyle}{
            >${TypographyStyle}{
                font-weight: 600;
            }
        }
        `
    },
    productActionStylesGridView: {
        css: css`
        padding: 0px 15px 50px;
        white-space: pre-wrap;
        display: flex;
        flex-direction: column;
        >${TypographyStyle}{
            >${TypographyStyle}{
                font-weight: 600;
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`padding: 0px 15px 15px;`,
                null,
                null,
        ],"max",)}
        `
    },
    pricingMainWrapper: {
        css: css`
        display: flex;
        flex-direction: row;
        padding: 0px 15px;
        flex-wrap: wrap;
        `
    },
    availabilityWrapper: {
        css: css`
            padding: 0px 15px;
            >${GridWrapper}{
                >${GridOffset}{
                    >${GridItemStyle}{
                        >${StyledButton}{
                            >${TypographyStyle}{
                                font-size: 14px;
                            }
                        }
                        div{
                            >${TypographyStyle}{
                                font-size: 14px;
                            }
                        }
                    }
                }
            }
        `,
    },
    availabilityTableWrapper: {
        css: css`
            display: none;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                display: block;
                padding: 0px 15px;
                >${GridWrapper}{
                    >${GridOffset}{
                        >${GridItemStyle}{
                            >${StyledButton}{
                                >${TypographyStyle}{
                                    font-size: 14px;
                                }
                            }
                            div{
                                >${TypographyStyle}{
                                    font-size: 14px;
                                }
                            }
                        }
                    }
                }
                `,
                null,
                null,
            ],"max",)}
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            width: 100%;
            flex-direction: column;
            > section {
                > div {
                    display: flex;
                    justify-content: flex-start;
                    padding: 12px 15px 8px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    justify-content: flex-start; flex-flow: wrap;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                    > span {
                        font-size: 16px;
                        color: ${getColor("secondary")};
                    }
                }
            }
        `,
    },
    wrapperGridView: {
        css: css`
            display: flex;
            width: 100%;
            flex-direction: column;
            > section {
                > div {
                    display: flex;
                    justify-content: flex-start;
                    padding: 12px 15px 8px;
                    flex-flow: wrap;
                    > span {
                        font-size: 16px;
                        color: ${getColor("secondary")};
                    }
                }
            }
        `,
    },
    price: {
        wrapper: {
            css: css`
                > div[class^="sc"] {
                    > ${TypographyStyle} {
                        &:first-child {
                            /* display: none; */
                        }
                    }
                }
            `,
        },
    },
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                margin-top: 0px;
                padding: 0px 15px;
                > ${TypographyStyle} {
                    display: none;
                }
            `,
        },
    },
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: 8px 0;
            `,
        },
    },
    addToCartWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            margin-top: 0px;
            padding: 0px 15px;
        `,
    },
    addToCartWrapperGridView: {
        css: css`
            display: flex;
            align-items: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        align-items: flex-start;
                    `,
                    css`
                        align-items: flex-start;
                    `,
                    null,
                    null,
                    null,
                ])}
            margin-top: 0px;
            padding: 0px 15px;
            > ${FormFieldStyle} {
                margin: 0px 10px 0px 0px;
                width: calc(20% - 10px);
                min-width: 3rem;
            }
            > ${ButtonWrapper} {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-top: 10px;
                        `,
                        css`
                            margin-top: 10px;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
        `,
    },
    addToCartButton: {
        css: css`
            width: 100%;
            padding: 0 12px 0 12px;
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                margin: 0px 5px 0px 0px;
                width: calc(20% - 10px);
                min-width: 3rem;
                > ${TypographyStyle} {
                    display: none;
                }
                >${FormInputWrapper}{
                    >${InputStyle}{
                        &:focus, &:focus-within{
                            border: 2px solid ${getColor("primary")} !important;
                        }
                    }
                }
            `,
        },
    },
    addToListWrapper: {
        css: css`
            margin-top: 10px;
            min-height: 2rem;
            padding: 0px 15px;
            text-align: right;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        text-align: left;
                    `,
                    null,
                    null,
                    null,
                ],"max",)}
            > ${StyledButton} {
                &:hover{
                    text-decoration: underline;
                }
                >${TypographyStyle}{

                }
            }
        `,
    },
    addToListWrapperGridView: {
        css: css`
            margin-top: 10px;
            min-height: 2rem;
            padding: 0px 15px;
            text-align: left;
            > ${StyledButton} {
                &:hover{
                    text-decoration: underline;
                }
            }
        `,
    },
    logincontainer: {
        css: css`
            display: flex;
            justify-content: flex-end;
            padding: 0px 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 0px 15px 15px;
                            justify-content: center;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    logincontainerGridView: {
        css: css`
            display: flex;
            justify-content: center;
            padding: 0px 15px 15px;
        `,
    },
    loginToSeePriceButton: {
        variant: "primary",
    },
};

const styles = actionsStyles;

const ProductListActions: FC<Props> = ({
    productContext,
    settingsCollection,
    productSettings,
    showPrice,
    showAddToList,
    view,
    showAvailability,
    isAuthenticated,
}) => {
    const onLogintoSeePriceClick = () => {
        window.location.href = "/SignIn";
    };
    const productListingPrice = productContext.productInfo.pricing?.unitRegularPrice;
    const productQuoteRequired = productContext.product.quoteRequired;
    const productActionsSiteMessage = siteMessage("ProductActions_SiteMessage");

    return (
        <StyledWrapper {...(view === "List" ? styles.wrapper : styles.wrapperGridView)}>
            {(productListingPrice! < 1 && productQuoteRequired === false) ? (
                <StyledWrapper {...(view === "Grid" ? styles.productActionStylesGridView : styles.productActionStyles)}>
                    <Typography>{translate("Price:")}&nbsp; <Typography>Requires Quote</Typography></Typography>
                    <Typography>{productActionsSiteMessage}</Typography>
                </StyledWrapper>
            ) : 
            (
                <>
                {showPrice && (
                    <StyledWrapper {...styles.pricingMainWrapper}>
                        <Typography>{translate("Price:")}&nbsp;</Typography>
                        <ProductPrice
                            product={productContext}
                            showLabel={false}
                            showSavings={true}
                            showSavingsAmount={productSettings.showSavingsAmount}
                            showSavingsPercent={productSettings.showSavingsPercent}
                            extendedStyles={styles.price}
                        />
                        <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />
                    </StyledWrapper>
                )}
                <StyledWrapper {...(view === "Table" ? styles.availabilityTableWrapper : styles.availabilityWrapper)}>
                    <ProductContextAvailability extendedStyles={styles.availabilityStyles} />
                </StyledWrapper>
                <ProductUnitOfMeasureSelect extendedStyles={styles.unitOfMeasureSelect} />
                <StyledWrapper {...(view === "List" ? styles.addToCartWrapper : styles.addToCartWrapperGridView)}>
                    <ProductQuantityOrdered extendedStyles={styles.quantityOrdered} />
                    <ProductAddToCartButton
                        data-test-selector={`actionsAddToCart${productContext.product.id}`}
                        extendedStyles={styles.addToCartButton}
                    />
                </StyledWrapper>
                {showAddToList && (
                    <StyledWrapper {...(view === "List" ? styles.addToListWrapper : styles.addToListWrapperGridView)}>
                        <ProductAddToListLink
                            data-test-selector={`actionsAddToList${productContext.product.id}`}
                            extendedStyles={styles.addToListLink}
                        />
                    </StyledWrapper>
                )}
                {!isAuthenticated && (
                    <StyledWrapper {...(view === "List" ? styles.logincontainer : styles.logincontainerGridView)}>
                        {/* <Button
                            {...styles.loginToSeePriceButton}
                            onClick={onLogintoSeePriceClick}
                            data-test-selector="loginToSeePrice"
                        >
                            {translate("Login To See Price")}
                        </Button> */}
                        {/* <Typography>&nbsp;</Typography> */}
                    </StyledWrapper>
                )}
                </>
            )}
            
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(ProductListActions));
